<template>
  <header class="section-header">
    <div class="section-header__wrap">
      <div @click="handleOpenLink('')" class="section-header__logo">
        <img src="@/assets/images/header/logo.png"/>
      </div>
      <input
          v-model="valueChecked"
          type="checkbox"
          id="overlay-input"
      />
      <label for="overlay-input" id="overlay-button"><span></span></label>
      <div id="overlay" class="section-header__menus">
        <div
            v-for="(item, index) in headerMenus"
            :key="index"
            class="menu"
            :class="{ active : item.active }"
        >
          <router-link
              class="menu-item"
              :to="item.url"
              @click.native="handleChangeActive(index)"
          >
            {{ item.name }}
          </router-link>
        </div>
      </div>
      <div v-if="!$store.state.isLoggedIn" class="section-header__info">
        <button @click="handleOpenLink('register')" class="sign-up info">Join Now</button>
        <button @click="handleOpenLink('login')" class="sign-in info">Login</button>
      </div>
      <div v-else-if="$store.state.isLoggedIn" class="section-header__info">
        <button @click="handleOpenLink('account')" class="sign-up info">Account</button>
        <button @click="handleLogout" class="sign-in info">Logout</button>
      </div>
    </div>
  </header>
</template>
<script>
  import authService from '@/services/auth.service';
  import { headerMenus } from '@/resources/header';
export default {
  data() {
    return {
      valueChecked: false,
      headerMenus
    }
  },
  methods: {
    handleOpenLink(name) {
      this.valueChecked = false;
      return this.$router.push(`/${name}`);
    },
    handleChangeActive (index) {
      this.valueChecked = false;
      this.headerMenus.forEach((item, i) => {
        item.active = index === i;
      })
    },
    handleLogout() {
      this.valueChecked = false;
      authService.logout();
      this.$store.commit('logoutUser');
      this.$router.push('/login');
    }
  }
}
</script>
